/* eslint-disable @typescript-eslint/no-var-requires */
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

export const initDaysJs = () => {
    dayjs.extend(localizedFormat);
    dayjs.extend(relativeTime);
};

export const setDaysLocale = (lang: string) => dayjs.locale(lang);
